"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flash = void 0;
var flash = {
  "viewBox": "0 0 896 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M885 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"
    }
  }]
};
exports.flash = flash;